export default {"src":"/_next/static/media/mode_local.48d5d6f9.svg","height":448,"width":512,"blurWidth":0,"blurHeight":0};